import { DEAL_METRICS, PROPERTY_ASSET_TYPES } from "@loanbossinc/component-library";
import { isEmpty, remove } from "lodash";
import { getValueMetric } from "utils/metrics";

const shouldShowSquareFeet = deal => deal.properties &&
	deal.properties.some(p => p.assetTypeId !== PROPERTY_ASSET_TYPES.MULTIFAMILY &&
		p.assetTypeId !== PROPERTY_ASSET_TYPES.HOTEL);

export const determinePriceField = metricList => {
  // current priority of values for hero cards
  const priorityRank = [
    "Purchase Price",
    "Market Value",
    "Appraised Value"
  ];
  // container for price field objects
  const priceFieldObjs = [];
  // looping through metric list, checking if they include each priceField, pushes to priceFieldObjs if true
  for (const metricObj of metricList) {
    if (priorityRank.includes(metricObj.label)) {
      priceFieldObjs.push(metricObj);
    }
  }
  // looping through priceFields
  for (const priceField of priceFieldObjs) {
    // logic for all three if statements is if label matches the corresponding index (rank) in the priority rank and that value is greater than 0, remove the other two fields
    if (priceField.label === priorityRank[0] && priceField.decimalValue > 0 && priceField.decimalValue) {
      remove(metricList, metricObj => metricObj.label === priorityRank[1]);
      remove(metricList, metricObj => metricObj.label === priorityRank[2]);

      return;
      // Market Value is second priority
    } else if (priceField.label === priorityRank[1] && priceField.decimalValue > 0 && priceField.decimalValue) {
      remove(metricList, metricObj => metricObj.label === priorityRank[0]);
      remove(metricList, metricObj => metricObj.label === priorityRank[2]);

      return;
      // Appraised Value is thrid priority
    } else if (priceField.label === priorityRank[2] && priceField.decimalValue > 0 && priceField.decimalValue) {
      remove(metricList, metricObj => metricObj.label === priorityRank[0]);
      remove(metricList, metricObj => metricObj.label === priorityRank[1]);

      return;
    }
  }
};

export const getMetricList = (deal, loan) => {
  const metricList = [];
  
  let earliestClosingDate;
    
  if (!!loan && !!loan.details?.closingDate) {
    earliestClosingDate = loan.details.closingDate;
  }
  else {
    const earliestClosedLoan = findEarliestClosedLoan(deal);
    if (!!earliestClosedLoan && !!earliestClosedLoan.closingDate) {
      earliestClosingDate = earliestClosedLoan.closingDate;
    }
  }
  
  const closingDateMetric = {
    metricId: DEAL_METRICS.CLOSING_DATE,
    label: "Closing Date",
    dateValue: earliestClosingDate
  };
  metricList.push(closingDateMetric);
  
  if (!loan) {
    const valueMetric = getValueMetric(deal);

    if (valueMetric) {
      metricList.push({
        ...valueMetric.data,
        metricId: valueMetric.id,
        label: valueMetric.label
      });
    }

    const unitsOrAreaMetric = getUnitsOrAreaMetric(deal);
    metricList.push(unitsOrAreaMetric);
  }
    
  return metricList;
};

const findEarliestClosedLoan = (deal) => {
  return deal?.loans?.filter(someLoan => !!someLoan.closingDate).reduce((lhs, rhs) => {
    if (!lhs && !!rhs) {
      return rhs;
    }
    else if (!!lhs && !rhs) {
      return lhs;
    }
    else {
      return Date(lhs.closingDate) < Date(rhs.closingDate) ? lhs : rhs;
    }
  }, null);
};

const getUnitsOrAreaMetric = (deal) => {
  const totalUnits = deal.properties.reduce((total, property) => total + property.units, 0);
  const totalArea = deal.properties.reduce((total, property) => total + property.squareFeet, 0);
  let unitsOrAreaMetric = {};
  
  if (!!totalUnits) {
    unitsOrAreaMetric = {
      metricId: DEAL_METRICS.MF_UNITS,
      label: "Units",
      integerValue: totalUnits
    };
  }
  else if (!totalUnits && !!totalArea) {
    unitsOrAreaMetric = {
      metricId: DEAL_METRICS.SQUARE_FEET,
      label: "Square Feet",
      decimalValue: totalArea
    };
  }
  else {
    unitsOrAreaMetric = {
      metricId: DEAL_METRICS.MF_UNITS,
      label: "Units",
      displayValue: "--"
    };
  }
  
  return unitsOrAreaMetric;
};

export default { getMetricList, determinePriceField };
